import styled from 'styled-components';

const Wrapper = styled.div`
  img {
    width: 100%;
  }
`;
export default Wrapper;
